import { Button, Input } from "@ui";
import style from "./TariffExtension.module.scss";
import { IProxy } from "@interfaces/user/proxy";
import { useExtensionValidityPeriodMutation } from "@RTKQuery/user/purchases/purchases";
import { useState } from "react";
import cn from "classnames";
import { useGetUserTariffsQuery } from "@RTKQuery/user/tariffs/tariffs";
import { RiLoader5Fill } from "react-icons/ri";
import { useAppSelector } from "store/hooks";

export function TariffExtension({
    data
}: {
    data: IProxy
}) {
    const { data: dataTariffs, isFetching } = useGetUserTariffsQuery()

    const { activePaginationLimit, activePaginationPage, activeSearchParameter, activeTags } = useAppSelector(state => state.myProxiesUserPage)

    const [extensionValidityPeriod, { isSuccess, isLoading, reset, error }] = useExtensionValidityPeriodMutation();

    const [term, setTerm] = useState<number>(3)
    const [numberPackages, setNumberPackages] = useState<string>("1")

    const totalPrice = (dataTariffs
    ?.find(tariff => tariff.name === data.tariff_name)?.rental_periods
    .find(period => period.rent_time === term)?.price || 0) * Number(numberPackages) || 0

    return (
        <div className={style.container}>
            <p className="text-center text-[#1B1B1D] text-[16px] font-semibold leading-normal mb-[30px]">Термін продовження</p>

            <div className={style.readyValues}>
                {["3 дня", "7 днів", "30 днів", "90 днів"].map((item, i) => (
                <button
                    key={i}
                    type="button"
                    className={cn(
                        style.value,
                        String(term) === item.replace(/\D/g, "") && style.value_active,
                    )}
                    onClick={() => {
                        setTerm(Number(item.replace(/\D/g, "")))
                    }}
                >
                    {item}
                </button>
                ))}
            </div>

            <div className="flex items-center gap-[20px] mb-[30px]">
                <Input
                    value={numberPackages}
                    label="Кількість пакетів"
                    onChange={(value) => {
                        setNumberPackages(value)
                    }}
                    onBlur={() => {
                        setNumberPackages(Number(numberPackages) ? String(Number(numberPackages)) : "1")
                    }}
                />
                {
                    isFetching
                    ?  <RiLoader5Fill className={"animate-spin"} />
                    : <p className="font-medium">
                        {term * Number(numberPackages) || 0} 
                        <span className="font-normal"> {(term * Number(numberPackages) || 0) === 3 ? 'дня' : 'днів'}</span> 
                        = ${totalPrice}
                    </p>
                }
            </div>

            <Button
                tabIndex={-1}
                text={
                    isSuccess
                        ? "Успішно збережено"
                        : "Продовжити"
                }
                color="blue"
                customStyle={{
                    button: "!w-[180px] !h-[38px]",
                    width: "!mx-auto"
                }}
                loading={isLoading}
                errors={[
                    (error && ((extractError) => {
                        return extractError(error)
                    }))
                ]}
                onClick={() => {
                    extensionValidityPeriod({
                        purchase_id: data.id,
                        term,
                        numberPackages: Number(numberPackages),
                        totalPrice,
                        params: {
                            limit: activePaginationLimit,
                            page: activePaginationPage,
                            search: activeSearchParameter,
                            tag_ids: activeTags
                        },
                    });
                }}
                resetStatus={() => {
                    reset();
                }}
            />
        </div>
    )
}